import { api } from '@/services/api'

const bootstrapCache = new Map()

/**
 * Inicia sessão pública (cookie HttpOnly) para consumir /api/public/* pelo navegador.
 *
 * @param {string} context sales|reseller_sales|renewal|test|recovery|general
 * @param {string} [slug]
 */
export async function ensurePublicSession(context = 'general', slug = '') {
  const key = `${context}:${slug || ''}`
  if (bootstrapCache.has(key)) {
    return bootstrapCache.get(key)
  }

  const promise = api
    .post(
      '/public/session/bootstrap',
      {
        context,
        slug: slug || undefined,
      },
      {
        withCredentials: true,
      }
    )
    .then((response) => {
      if (!response?.success) {
        throw new Error(response?.message || 'Public session bootstrap failed')
      }
      return response
    })
    .catch((error) => {
      bootstrapCache.delete(key)
      throw error
    })

  bootstrapCache.set(key, promise)
  return promise
}

export function resetPublicSessionCache() {
  bootstrapCache.clear()
}

/**
 * @param {import('vue-router').RouteLocationNormalized} route
 */
export function resolvePublicSessionContext(route) {
  const name = route.name
  const slug = String(route.params?.slug || '')

  switch (name) {
    case 'public-sales':
      return { context: 'sales', slug }
    case 'public-reseller-sales':
      return { context: 'reseller_sales', slug }
    case 'public-renewal':
      return { context: 'renewal', slug: '' }
    case 'public-test':
      return { context: 'test', slug }
    case 'credential-recovery':
      return { context: 'recovery', slug: '' }
    default:
      return null
  }
}

export function routeRequiresPublicSession(route) {
  return resolvePublicSessionContext(route) !== null
}
